export const gtgSrc = (tag, index = 0) => `/gtg-${tag}-${index + 1}/`;
